import { GatsbyImageDataArgs, getGatsbyImageData } from 'gatsby-source-sanity'
import { ImageNode } from 'gatsby-source-sanity/lib-es5/images/getGatsbyImageProps'
import React, { FC } from 'react'

const SanityConfig = {
  projectId: process.env.GATSBY_SANITY_PROJECT_ID || `CONFIG_NOT_SET`,
  dataset: process.env.GATSBY_SANITY_DATASET || `CONFIG_NOT_SET`,
};

export const gatsbyImage = (image: ImageNode, args?: GatsbyImageDataArgs ) => getGatsbyImageData(image, { ...args }, SanityConfig).images.fallback.src;

export interface ImageProps {
  image: any
  args?: GatsbyImageDataArgs
  className?: string
  title?: string
}

const Image: FC<ImageProps> = ({ image, title, args, className, ...attrs }) => {
  if (!image?.asset) {
    return <></>;
  }

  const imageData = gatsbyImage(image, args);
  
  return (
    <img
      className={className || undefined}
      src={imageData}
      alt={title || ''}
      {...attrs}
    />
  );
};

export default Image;
